// /UI/Dropzone/hooks/useNotifications.js
import { useState, useCallback } from 'react';
import { debounce } from 'lodash';
import { NOTIFICATION_DURATION } from '../utils/constants';

/**
 * Hook to manage notifications
 * @returns {Object} Notification state and methods
 */
export const useNotifications = () => {
  const [notifications, setNotifications] = useState([]);

  // Add a new notification
  const addNotification = useCallback((type, message) => {
    const id = Date.now();
    setNotifications(prev => [...prev, { id, type, message }]);

    // Auto-remove after set duration
    setTimeout(() => {
      removeNotification(id);
    }, NOTIFICATION_DURATION);
  }, []);

  // Remove a notification by ID
  const removeNotification = useCallback(id => {
    setNotifications(prev => prev.filter(notification => notification.id !== id));
  }, []);

  // Throttled notification to prevent spamming
  const throttledNotification = useCallback(
    debounce((type, message) => {
      addNotification(type, message);
    }, 1000),
    [addNotification]
  );

  return {
    notifications,
    addNotification,
    removeNotification,
    throttledNotification,
  };
};
